import { render, staticRenderFns } from "./Terminal.vue?vue&type=template&id=7872be0f&scoped=true&"
import script from "./Terminal.vue?vue&type=script&lang=js&"
export * from "./Terminal.vue?vue&type=script&lang=js&"
import style0 from "./Terminal.vue?vue&type=style&index=0&id=7872be0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7872be0f",
  null
  
)

export default component.exports